import { cn } from '@/lib/utils/utils';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useSafeBack } from '@/lib/hooks/use-safe-back';

export function BackButton({ onClick, className }) {
    const { goBack } = useSafeBack();

    const handleClick = onClick || goBack;

    return (
        <Button
            variant="plain"
            color="neutral"
            size="auto"
            onClick={handleClick}
            className={cn(
                'w-10 h-10 flex items-center justify-center bg-surface-hover hover:bg-surface-active transition-colors',
                className,
            )}
        >
            <ArrowLeft className="w-5 h-5 text-foreground" />
        </Button>
    );
}
